export const colors = {
  primaryGreen: "#5ae0a0",
  primaryBlack: "#000000",
};
